import Grid from "@mui/material/Grid";
import { useState } from "react";
import RffBooleanToggleField from "../components/finalForm/inputs/RffBooleanToggleField";
import RffEmailField from "../components/finalForm/inputs/RffEmailField";
import RffPhoneField from "../components/finalForm/inputs/RffPhoneField";
import RffTextField from "../components/finalForm/inputs/RffTextField";
import RffFullPageFormStepper from "../components/finalForm/RffFullPageFormStepper";

import TextOverflow from "../_src_shared/components/TextOverflow";
import RffAddressEditingField from "../components/finalForm/inputs/RffAddressEditingField";
import RffDateField from "../components/finalForm/inputs/RffDateField";
import RffFileUploadField from "../components/finalForm/inputs/RffFileUploadField";
import RffSelectToggleField from "../components/finalForm/inputs/RffSelectToggleField";
import RffSignatureField from "../components/finalForm/inputs/RffSignatureField";
import RffSsnField from "../components/finalForm/inputs/RffSsnField";
import RffConditional from "../components/finalForm/shared/RffConditional";
import RffGroup from "../components/finalForm/shared/RffGroup";
import Txt from "../components/typography/Txt";
import { useBorrowerSubmissionsHook } from "../hooks/useBorrowerSubmissionsHook";

const CreditAuthorizationFormScreen = ({ children }) => {
  const { loading, createCreditAuthorization } = useBorrowerSubmissionsHook();
  // const { loading, createCreditAuth } = useUnauthenticatedHook();
  const [success, setSuccess] = useState(false);
  const onFormSubmit = (data) => {
    console.log("Submit", data);
    createCreditAuthorization({
      payload: data,
      onSuccessFn: (d) => {
        // console.log("Success", d);
        setSuccess(true);
      },
      // onCompleteFn: (d) => {
      //   // console.log("Success", d);
      //   setSuccess(true);
      // },
    });
  };

  return (
    <>
      <RffFullPageFormStepper
        // formSpy
        className={"required"}
        loading={loading}
        success={success}
        // initialValues={{ subjectProperties: [{}] }}
        onSubmit={onFormSubmit}
        formTitle={"Credit Authorization"}
        // formTitle={"ResiLender Credit Authorization"}
        formDescription="Please provide the required information below. Let's start by learning a little more about you."
        finalStepLabel="Submit"
        sx={{
          ".input-wrapper-root.required": {
            border: "1px solid red",
          },
        }}
      >
        <BorrowerDetailsPage stepName="Borrower Details" />

        <UploadFilesPage stepName="Upload Files" />
        <ConfirmationPage stepName="Confirmation" />
      </RffFullPageFormStepper>
    </>
  );
};

const BorrowerDetailsPage = ({ testing }) => {
  return (
    <>
      <RffGroup title={"Borrower Details"}>
        <RffTextField name="firstName" label="First Name" size={6} required />
        <RffTextField name="lastName" label="Last Name" size={6} required />
        <RffPhoneField name="phone" label="Phone" required />
        <RffEmailField name="emailAddress" label="Email" required />
        <RffSelectToggleField
          name="citizenshipStatus"
          label="Please select your citizenship category"
          options={[
            "US Citizen",
            "Foreign National with SSN",
            "Foreign National",
            "Foreign National Non-Resident",
            "Other - Options do not apply",
          ]}
          required
        />

        <RffConditional
          testing={testing}
          operatorForMultiple={"OR"}
          rules={[
            { field: "citizenshipStatus", operator: "==", value: "US Citizen" },
            {
              field: "citizenshipStatus",
              operator: "==",
              value: "Foreign National with SSN",
            },
            {
              field: "citizenshipStatus",
              operator: "==",
              value: "Foreign National",
            },
          ]}
        >
          <RffAddressEditingField
            name="primaryAddress"
            label="Primary Address"
            required
          />
        </RffConditional>
        <RffConditional
          testing={testing}
          operatorForMultiple={"OR"}
          rules={[
            {
              field: "citizenshipStatus",
              operator: "==",
              value: "Foreign National Non-Resident",
            },
            {
              field: "citizenshipStatus",
              operator: "==",
              value: "Other - Options do not apply",
            },
          ]}
        >
          <RffTextField
            required
            name="nonUSborrowerAddress"
            label="Enter non-US address"
          />
        </RffConditional>

        <RffDateField name="dateOfBirth" label="Enter date of birth" required />
        <RffBooleanToggleField
          name="borrowerHasSSN"
          label="Do you have a US issued Social Security Number?"
          required
        />
        <RffConditional testing={testing} field={"borrowerHasSSN"} value={true}>
          <RffSsnField
            name="borrowerSSN"
            label="Social Security Number"
            required
          />
        </RffConditional>
        <RffSelectToggleField
          name="maritalStatus"
          label="What is your marital Status?"
          options={["Married", "Not Married"]}
          required
        />
      </RffGroup>
    </>
  );
};

const UploadFilesPage = ({ testing }) => {
  return (
    <>
      <RffGroup titleType="h2" title="Idenfication Upload">
        <RffFileUploadField
          label="Upload Photo Identification"
          docGroup={"Borrower Documents"}
          required
          docType={"Photo Identification"}
          helperText="Please ensure to upload both front and back of identification"
        />
      </RffGroup>
    </>
  );
};

const ConfirmationPage = ({ testing }) => {
  return (
    <>
      <RffGroup titleType="h2" title="Disclosure & Signature">
        <Grid item xs={12}>
          <TextOverflow title={"Authorization Agreement"}>
            <Txt>
              Applicant attests that this application is for financing of a
              business purpose loan and any subject properties covered under
              this application are not owner occupied, used as a second home or
              vacation property, and any recent use of the property as a primary
              residence will require supporting evidence that all guarantors and
              their family members are no longer occupying the residence.
            </Txt>
            <Txt>
              The actual terms and conditions upon which the Lender might extend
              credit are subject to satisfactory completion of due diligence,
              internal approval, satisfactory review of documentation and such
              other or different items and conditions as may be determined by
              the Lender following the completion of its underwriting (the
              “Underwriting and Approval Process”). As a result, notwithstanding
              any agreement of the parties to the contrary, (i) Lender’s
              approval of the loan documents shall not constitute a final
              approval of the loan and (ii) the loan documents shall not be
              considered final until the Underwriting and Approval Process is
              completed (as determined in Lender’s sole discretion).
            </Txt>
            <Txt>
              The borrower hereby agrees that all aforementioned information is
              true and in no means is false and intended to influence the credit
              underwriting of the Lender in regard to origination of the loan
              associated with the subject property or properties. Additionally,
              the borrower understands that this loan application does not
              constitute a commitment from the Lender to originate the loan
              associated with the subject property or properties. Lastly, the
              borrower acknowledges that all fees collected in relation to loan
              due diligence are non-refundable, in any circumstance.
            </Txt>
            <Txt>
              I hereby authorize and instruct the Lender and its
              vendors/affiliates to obtain and review my personal credit report,
              background checks, and all other reports and documents and
              involving due diligence in connection with my real estate loan. I
              understand and agree that the Lender and its vendors/affiliates
              intends to use the credit report for the purpose of evaluating my
              financial readiness to personally guarantee the real estate loan
              that I have applied for. My signature below authorizes the release
              to credit report and screening agencies of financial or other
              information that I have supplied to the Lender and its
              vendors/affiliates in connection with such evaluation.
              Authorization is further granted to the credit report and
              screening agencies to use a copy of this form to obtain any
              information the agencies may deem necessary to complete my credit
              report and/or background screenings.
            </Txt>
          </TextOverflow>
        </Grid>
        <RffSignatureField name="signature" label="Signature" required />
      </RffGroup>
    </>
  );
};
/**
 * Shared
 */

// const TextOverflow = ({ children, maxHeight = "280px" }) => {
//   return (
//     <Flx
//       column
//       gap={2}
//       sx={{
//         maxHeight: maxHeight,
//         overflowY: "auto",
//         p: 2,
//         border: `1px solid ${grey[300]}`,
//         borderRadius: "4px",
//       }}
//     >
//       {children}
//     </Flx>
//   );
// };

export default CreditAuthorizationFormScreen;
